import * as actions from './actionTypes';
import { v4 as uuid } from 'uuid';
import { loadState } from './session-store';
import { Utility } from '../utils/utility.service';
import { IAppState } from './state-interfaces';
import { CONSTANTS } from '../constants/constants';
import { combinedReducers } from './combinedReducers';

export const INITIAL_STATE: IAppState = {
  correlation_ID: uuid(),
  user: {
    userId: '',
    email: '',
    phoneNumber: '',
    name: '',
    userType: '',
    invationPending: false,
    userImgName: '',
    userImgKey: '',
    userImgUrl: '',
  },
  userObject: {},
  updateProfileData: '',
  preferredLanguage: '',
  userBrand: '',
  errorMessage: '',
  successMessage: '',
  showHeader: false,
  sharedData: {
    headerTab: CONSTANTS.DASHBOARD,
    selectedSite: {
      siteName: '',
      siteId: '',
      siteTimeZone: '',
      commonAccessControl: true,
    },
    selectedBuilding: {
      buildingName: null,
      buildingId: null,
    },
    selectedFloor: {
      floorName: null,
      floorId: null,
    },
    selectedUnit: {
      unitName: null,
      unitId: null,
    },
    selectedAccessPoint: {
      accessPointName: null,
      accessPointId: null,
    },
    editMode: {
      building: false,
      floor: false,
    },
  },
  appData: {
    sites: undefined,
    buildings: undefined,
    floors: undefined,
  },
  isLoggedIn: false,
  usersList: [],
  usersTabList: [],
  deviceList: [],
  partnerDeviceList: [],
  unitOrAccessPointUserList: [],
  accessPointActivities: undefined,
  buildingActivities: undefined,
  unitActivities: undefined,
  unitFilterActivities: undefined,
  dashboardActivities: undefined,
  activeIssuesActivity: undefined,
  rememberMe: { state: false, value: '', type: 'email' },
};

export const buildingActivitiesReducer = (state = INITIAL_STATE, action: any) => {
  switch (action.type) {
    case actions.UPDATE_BUILDING_ACTIVITIES:
      return {
        ...state,
        buildingActivities: {
          ...state.buildingActivities,
          events: [
            ...(state.buildingActivities?.events || []),
            ...(action.buildingActivities?.events || []),
          ],
          totalRecords: action.buildingActivities?.totalRecords || state.buildingActivities?.totalRecords,
          cursor: action.buildingActivities?.cursor || state.buildingActivities?.cursor,
        },
      };
    default:
      return state;
  }
};

export function rootReducer(state: IAppState, action: any): IAppState {
  let persistedState = loadState();
  if (persistedState) {
    if (!Utility.compareJson(persistedState, state)) {
      state = Object.assign({}, state, persistedState);
    }
  }

  if (!state.buildingActivities) {
    state.buildingActivities = {
      events: [],
      totalRecords: 0,
      cursor: null,
    } as { events: any[]; totalRecords: any; cursor: any; };
  }

  if (!state.userActivities) {
    state.userActivities = {
      events: [],
      totalRecords: 0,
      cursor: null,
    } as { events: any[]; totalRecords: any; cursor: any; };
  }
  const combinedState = combinedReducers(
    {
      buildingActivities: state.buildingActivities,
      userActivities: state.userActivities,
      // Add other parts of the state if needed
    },
    action
  );

  state = {
    ...state,
    ...combinedState,
  };

  switch (action.type) {
    case actions.LOGOUT: {
      const newState = INITIAL_STATE;
      newState.userBrand = state.userBrand;
      newState.rememberMe = state.rememberMe;
      return Object.assign({}, state, newState);
    }
    case actions.UPDATE_USER:
      return Object.assign({}, state, {
        user: action.user,
      });
    case actions.UPDATE_IS_LOGGED_IN:
      return Object.assign({}, state, {
        isLoggedIn: action.isLoggedIn,
      });
    case actions.UPDATE_USER_OBJECT:
      return Object.assign({}, state, {
        userObject: action.userObject,
      });
    case actions.UPDATE_USERS_TAB_LIST:
      return Object.assign({}, state, {
        usersTabList: action.usersTabList,
      });
    case actions.UPDATE_USERS_LIST:
      return Object.assign({}, state, {
        usersList: action.usersList,
      });
    case actions.UPDATE_DASHBOARD_USERS_LIST:
      return Object.assign({}, state, {
        dashboardUsersList: action.dashboardUsersList,
      });
    case actions.UPDATE_UNIT_AND_ACCESSPOINT_USERS_LIST:
      return Object.assign({}, state, {
        unitOrAccessPointUserList: action.unitOrAccessPointUserList,
      });
    case actions.UPDATE_DEVICE_LIST:
      return Object.assign({}, state, {
        deviceList: action.deviceList,
      });
    case actions.UPDATE_PARTNER_DEVICE_LIST:
      return Object.assign({}, state, {
        partnerDeviceList: action.partnerDeviceList,
      });
    case actions.UPDATE_HEADER_STATE:
      return Object.assign({}, state, {
        showHeader: action.showHeader,
      });
    case actions.UPDATE_SHARED_DATA:
      return Object.assign({}, state, {
        sharedData: action.sharedData,
      });
    case actions.UPDATE_SITES:
      return Object.assign({}, state, {
        appData: Object.assign({}, state.appData, { sites: action.sites }),
      });
    case actions.UPDATE_BUILDINGS:
      return Object.assign({}, state, {
        appData: Object.assign({}, state.appData, {
          buildings: action.buildings,
        }),
      });
    case actions.UPDATE_FLOORS:
      return Object.assign({}, state, {
        appData: Object.assign({}, state.appData, { floors: action.floors }),
      });
    case actions.UPDATE_VERIFICATION:
      return Object.assign({}, state, {
        verify: action.object,
      });
    case actions.CHANGE_LANGUAGE:
      return Object.assign({}, state, {
        preferredLanguage: action.preferredLanguage,
      });
    case actions.UPDATE_FORGOT_PASSWORD_FLOW:
      return Object.assign({}, state, {
        forgotPassword: action.forgotPassword,
      });
    case actions.UPDATE_CORRELAION_ID:
      return Object.assign({}, state, { correlation_ID: uuid() });
    case actions.LAST_ACTIVITY_TIME:
      return Object.assign({}, state, { time: action.time });
    case actions.UPDATE_USER_BRAND:
      if (action.brand)
        return Object.assign({}, state, { userBrand: action.brand });
      break;
    case actions.ADD_ERROR_MESSAGE:
      return Object.assign({}, state, {
        errorMessage: action.msg,
      });
    case actions.ADD_SUCCESS_MESSAGE:
      return Object.assign({}, state, {
        successMessage: action.msg,
      });
    case actions.UPDATE_ACCESSPOINT_ACTIVITIES:
      return Object.assign({}, state, {
        accessPointActivities: { ...action.accessPointActivities },
      });
    case actions.PREPEND_USER_LIST:
      return {
        ...state,
        usersList: [...state.usersList!, ...action.usersList],
      };
    case actions.PREPEND_USER_TAB_LIST:
      return {
        ...state,
        usersTabList: [...state.usersTabList!, ...action.usersTabList],
      };
    case actions.PREPEND_ACCESSPOINT_ACTIVITIES:
      return Object.assign({}, state, {
        accessPointActivities: {
          totalRecords: action.accessPointActivities?.totalRecords,
          cursor: action.accessPointActivities?.cursor,
          events: [
            ...state.accessPointActivities!.events!,
            ...action.accessPointActivities.events,
          ],
        },
      });
    case actions.UPDATE_UNIT_ACTIVITIES:
      return Object.assign({}, state, {
        unitActivities: { ...action.unitActivities },
      });
    case actions.UPDATE_UNIT_FILTER_ACTIVITIES:
      return Object.assign({}, state, {
        unitFilterActivities: action.unitActivities,
      });
    case actions.PREPEND_UNIT_ACTIVITIES:
      return Object.assign({}, state, {
        unitActivities: {
          totalRecords: action.unitActivities?.totalRecords,
          cursor: action.unitActivities.cursor,
          events: [
            ...state.unitActivities!.events!,
            ...action.unitActivities.events,
          ],
        },
      });
    case actions.PREPEND_UNIT_FILTER_ACTIVITIES:
      return Object.assign({}, state, {
        unitFilterActivities: {
          totalRecords: action.unitActivities.totalRecords,
          cursor: action.unitActivities.cursor,
          events: [
            ...state.unitActivities!.events!,
            ...action.unitActivities.events,
          ],
        },
      });
    case actions.UPDATE_DASHBOARD_ACTIVITIES:
      return Object.assign({}, state, {
        dashboardActivities: action.dashboardActivities,
      });
    case actions.UPDATE_ACTIVE_ISSUES:
      return Object.assign({}, state, {
        activeIssuesActivity: action.activeIssuesActivity,
      });
    case actions.UPDATE_REMEMBER_ME:
      return Object.assign({}, state, {
        rememberMe: action.rememberMe,
      });
  }
  return state;
}
